<div class="page-container">
  <div class="page-header">
    <h1>My Orders</h1>
    <p>Track and manage your ticket purchases</p>
  </div>

  <div class="orders-card">
    <div class="table-container">
      <nz-table
        #ordersTable
        [nzData]="orders"
        [nzLoading]="loading"
        [nzTotal]="totalItems"
        [nzPageIndex]="pageIndex"
        [nzPageSize]="pageSize"
        [nzFrontPagination]="false"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50]"
        (nzPageIndexChange)="onPageIndexChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
        nzSize="middle"
      >
        <thead>
          <tr>
            <th>Order</th>
            <th>Date</th>
            <th>Status</th>
            <th>Payment</th>
            <th class="text-right">Amount</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let order of ordersTable.data" class="clickable-row" (click)="goToOrder(order.orderNumber)">
            <td>
              <span class="order-number">#{{ order.orderNumber }}</span>
            </td>
            <td class="text-secondary">{{ formatDate(order.orderDate) }}</td>
            <td>
              <span class="status-badge" [ngClass]="'status-' + order.status?.toLowerCase()">
                {{ order.status }}
              </span>
            </td>
            <td class="text-secondary">{{ order.paymentMethod }}</td>
            <td class="text-right">
              <span class="amount tabular-nums">
                {{ formatCurrency(order.amount + (order.processingFee || 0), order.currencyCode) }}
              </span>
              <span *ngIf="order.processingFee > 0" class="fee-note">
                incl. {{ formatCurrency(order.processingFee, order.currencyCode) }} fee
              </span>
            </td>
            <td class="text-right">
              <a
                nz-button
                nzType="default"
                nzSize="small"
                class="view-button"
                [routerLink]="['/orders', order.orderNumber]"
                (click)="$event.stopPropagation()"
              >
                View
              </a>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>
